<div
  #button
  *ngIf="!node.header"
  class="single-select-node"
  [class.selected]="node.selected"
  [class.highlighted]="node.highlighted"
  [class.disabled]="disabled || node.disabled"
  (click)="onClicked($event)"
>
  <riv-icon [name]="'Check'" *ngIf="node.selected" [size]="16"></riv-icon>
  <span class="label" [title]="getTooltipFromNode(node, displayId)">
    <span class="label-id rv-bold" *ngIf="displayId"> {{ node.id }} - </span>
    <span class="label-title">
      <fuzzy-highlight
        [text]="node.title"
        [indices]="node.titleHighlightIndices"
      ></fuzzy-highlight>
    </span>
    <span
      *ngIf="node.subtitle"
      class="label-subtitle"
      [class.split]="node.splitTitle"
    >
      <fuzzy-highlight
        [text]="node.subtitle"
        [indices]="node.subtitleHighlightIndices"
      ></fuzzy-highlight>
    </span>
  </span>
</div>
<div *ngIf="node.header" class="single-select-node header">
  <span class="label" [title]="getTooltipFromNode(node, displayId)">
    <span class="label-id rv-bold" *ngIf="displayId"> {{ node.id }} - </span>
    <span class="label-title">
      {{ node.title }}
    </span>
    <div *ngIf="node.subtitle" class="label-subtitle">
      {{ node.subtitle }}
    </div>
  </span>
</div>
